"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedHeaderApi = void 0;
// Open/Close
// Animate side to side
var menuState_1 = __importDefault(require("./menuState"));
var debounce_1 = __importDefault(require("../../utilities/debounce"));
var searchBarHandler_1 = __importDefault(require("./searchBarHandler"));
var logoHandler_1 = __importDefault(require("./logoHandler"));
var sticky_1 = __importDefault(require("./sticky"));
var header = document.querySelector('.Header');
exports.FixedHeaderApi = header ? sticky_1.default(header) : false;
exports.default = (function () {
    var headerMainNav = document.querySelector('.Header__mainNav');
    var subMenuContainer = document.querySelector('.HeaderSubNav__container');
    var subMenuGroups = Array.from(document.querySelectorAll('.HeaderSubNav__group'));
    var headerSubNav = document.querySelector('.HeaderSubNav');
    var headerMainNavItem = Array.from(document.querySelectorAll('.HeaderMainNav__item > a'));
    if (!exports.FixedHeaderApi ||
        !headerMainNav ||
        !headerSubNav ||
        !subMenuContainer ||
        !headerMainNavItem) {
        return;
    }
    var grabSubMenuSizes = function () {
        var results = null;
        // Grab both these CSS values for future use
        var containerTransform = subMenuContainer.style.transform;
        var containerTransition = subMenuContainer.style.transition;
        var headerSubNavTransition = headerSubNav.style.transition;
        // Remove these for the time being. Because they mess up the menu size calculations
        subMenuContainer.style.transform = 'none';
        subMenuContainer.style.transition = 'none';
        headerSubNav.style.transition = 'none';
        headerSubNav.style.width = '';
        results = subMenuGroups.reduce(function (map, menu) {
            menu.style.width = '';
            var name = menu.dataset.jsTarget;
            var details = menu.getBoundingClientRect();
            map.set(name, details);
            return map;
        }, new Map());
        // headerSubNav.style.width = mainContainerWidth;
        subMenuContainer.style.transform = containerTransform;
        subMenuContainer.style.transition = containerTransition;
        headerSubNav.style.transition = headerSubNavTransition;
        return results;
    };
    var subMenuSizes = grabSubMenuSizes();
    var updateSubMenuGroupWidth = function () { return (subMenuGroups.forEach(function (menu) {
        var name = menu.dataset.jsTarget;
        menu.style.width = subMenuSizes.get(name).width + 'px';
    })); };
    updateSubMenuGroupWidth();
    var _a = (function () {
        var closeDropdownTimeout;
        // This function has a timeout. This allows the application to delay a second to see 
        // where the user is moving the mouse. In some situations it is desied to transition
        // smoothly between two submenus, without of closing and reopening.
        //
        // Current timeout of 75ms was picked randomlly because it is about the time
        // it takes to move between the left most item to the right most. Allowing
        // for transitions between any submenu group.
        var closeSubMenu = function () {
            closeDropdownTimeout = setTimeout(function () {
                header === null || header === void 0 ? void 0 : header.classList.remove('Header--subMenuVisible');
                subMenuContainer === null || subMenuContainer === void 0 ? void 0 : subMenuContainer.classList.add('is-hidden');
                exports.FixedHeaderApi.unfreeze();
                searchBarHandler_1.default('fadeIn');
                logoHandler_1.default('');
                if (menuState_1.default.activeMenuItem.linkNode && menuState_1.default.activeMenuItem.subMenuNode) {
                    menuState_1.default.activeMenuItem.linkNode.setAttribute('aria-expanded', 'false');
                    menuState_1.default.activeMenuItem.subMenuNode.classList.add('is-hidden');
                    menuState_1.default.activeMenuItem.subMenuNode.classList.remove('HeaderSubNav--transitionRight');
                    menuState_1.default.activeMenuItem.subMenuNode.classList.remove('HeaderSubNav--transitionLeft');
                }
                menuState_1.default.open = false;
            }, 0);
        };
        // This will prevent the above closeSubMenu function from actually doing anything
        var cancelCloseSubMenu = function () { return clearTimeout(closeDropdownTimeout); };
        return [closeSubMenu, cancelCloseSubMenu];
    })(), closeSubMenu = _a[0], cancelCloseSubMenu = _a[1];
    var transitionToNewSubMenu = function (item, group) {
        // Just in case. If this happens something is wrong, and we should just close everything
        // and restart
        if (!menuState_1.default.activeMenuItem.linkNode || !menuState_1.default.activeMenuItem.subMenuNode) {
            // try again to close
            closeSubMenu();
            return false;
        }
        // If the currently opened submenu is the same as the main menu item being hovered on
        // Then just do nothing, we are already done.
        if (menuState_1.default.activeMenuItem.linkNode == item) {
            return false;
        }
        var oldActiveLink = menuState_1.default.activeMenuItem.linkNode;
        var oldActiveLinkLeft = oldActiveLink.getBoundingClientRect().left;
        var itemLeft = item.getBoundingClientRect().left;
        var animationClass = itemLeft > oldActiveLinkLeft ? 'HeaderSubNav--transitionRight' : 'HeaderSubNav--transitionLeft';
        group.classList.add(animationClass);
        group.classList.remove('is-hidden');
        if (menuState_1.default.activeMenuItem.linkNode && menuState_1.default.activeMenuItem.subMenuNode) {
            menuState_1.default.activeMenuItem.linkNode.setAttribute('aria-expanded', 'false');
            menuState_1.default.activeMenuItem.subMenuNode.classList.add('is-hidden');
            menuState_1.default.activeMenuItem.subMenuNode.classList.remove('HeaderSubNav--transitionRight');
            menuState_1.default.activeMenuItem.subMenuNode.classList.remove('HeaderSubNav--transitionLeft');
        }
    };
    var openSubMenu = function (item) {
        var subMenu = item.dataset.jsAction;
        var subMenuGroup = document.querySelector(".HeaderSubNav__group[data-js-target=\"" + subMenu + "\"]");
        if (!subMenu || !subMenuGroup) {
            return;
        }
        exports.FixedHeaderApi.freeze();
        cancelCloseSubMenu();
        searchBarHandler_1.default('fadeOut');
        // On the homepage, with a different header type when at top of page
        // we need to shrink the logo a bit for full witdh submenu or searchbar
        if (subMenuGroup.classList.contains('HeaderSubNav--complex')) {
            logoHandler_1.default('shrink');
        }
        // Prep work to open up the container for the submenus
        header.classList.add('Header--subMenuVisible');
        subMenuContainer.classList.remove('is-hidden');
        item.setAttribute('aria-expanded', 'true');
        if (menuState_1.default.open) {
            transitionToNewSubMenu(item, subMenuGroup);
        }
        else {
            // Now reveal the specific submenu
            subMenuGroup.classList.remove('is-hidden');
        }
        var subMenuDimensions = subMenuSizes.get(subMenu);
        if (!subMenuGroup.classList.contains('HeaderSubNav--complex')) {
            // Default left position is the calculated position for the text in the 
            // dropdown to align with the text in the menu item. Padding between the 
            // two is different so paddingDifference accounts for that
            var paddingDifference = 8;
            var left = item.getBoundingClientRect().left - paddingDifference;
            // If we are up against the far right of the screen, and overflowing
            // then we will reposition the submenu against the right window edge
            var subMenuRightPosition = left + subMenuDimensions.width;
            if (subMenuRightPosition > window.innerWidth) {
                left = left - (subMenuRightPosition - window.innerWidth);
            }
            headerSubNav.style.left = left + 'px';
        }
        else {
            headerSubNav.style.left = 0 + 'px';
        }
        if (!menuState_1.default.open) {
            headerSubNav.style.transitionProperty = 'opacity';
            setTimeout(function () { return (headerSubNav.style.transitionProperty = ''); }, 25);
        }
        headerSubNav.style.height = subMenuDimensions.height + 'px';
        headerSubNav.style.width = subMenuDimensions.width + 'px';
        // Update the state
        menuState_1.default.open = true;
        menuState_1.default.activeMenuItem.linkNode = item;
        menuState_1.default.activeMenuItem.subMenuNode = subMenuGroup;
        var WINDOW_OFFSET = window.pageYOffset;
        var SCROLL_OFFSET = 80;
        var onScrollCloseMenu = function () {
            if (Math.abs(WINDOW_OFFSET - window.pageYOffset) > SCROLL_OFFSET) {
                closeSubMenu();
                window.removeEventListener('scroll', onScrollCloseMenu);
            }
        };
        window.addEventListener('scroll', onScrollCloseMenu);
    };
    // One resize we need two things to happen
    // 1. Update submenu sizes
    // 2. set the submenu group contains to that width
    //    Settings the width prevents word wrapping ugliness
    window.addEventListener('resize', debounce_1.default(function () {
        subMenuSizes = grabSubMenuSizes();
        updateSubMenuGroupWidth();
    }, 250));
    // Primary Events for Sub Menu Block
    subMenuContainer.addEventListener('mouseenter', cancelCloseSubMenu);
    subMenuContainer.addEventListener('mouseleave', closeSubMenu);
    // Events for menu items
    headerMainNavItem.forEach(function (item) {
        item.addEventListener('mouseenter', function () { return openSubMenu(item); });
        item.addEventListener('mouseleave', closeSubMenu);
    });
});
